import { NgModule } from '@angular/core';
import { PageTitleBarComponent } from './page-title-bar/page-title-bar.component';
import { SharedModule } from 'shared';
import { UploadCargaMasivaComponent } from './upload-carga-masiva/upload-carga-masiva.component';
import { UploadCargaMasivaService } from './upload-carga-masiva/upload-carga-masiva.service';
import { LayoutComponent } from './layout/layout.component';
import { MenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
import { PageContainerComponent } from './page-container/page-container.component';
import { ComparadorUniversidadComponent } from './comparador/comparador-universidad/comparador-universidad.component';
import { ComparadorProgramaComponent } from './comparador/comparador-programa/comparador-programa.component';
import { ModalCambiarUbicacionComponent } from './modals/modal-cambiar-ubicacion/modal-cambiar-ubicacion.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { VisorRangoEdadComponent } from './visor-rango-edad/visor-rango-edad.component';
import { ModalCambiarLocalUniversidadComponent } from './modals/modal-cambiar-local-universidad/modal-cambiar-local-universidad.component';
import { ModalUbicacionLocalesUniversidadComponent } from './modals/modal-ubicacion-locales-universidad/modal-ubicacion-locales-universidad.component';
import { ModalLocalesUniversidadComponent } from './modals/modal-locales-universidad/modal-locales-universidad.component';
import { ModalPorQueUbicarmeComponent } from './modals/modal-por-que-ubicarme/modal-por-que-ubicarme.component';
import { ButtonScrollComponent } from './button-scroll/button-scroll.component';
import { ModalSolicitudApiComponent } from './modals/modal-solicitud-api/modal-solicitud-api.component';
import { ModalBuscaKeyComponent } from './modals/modal-busca-key/modal-busca-key.component';
import { ModalEncuestaApiComponent } from './modals/modal-encuesta-api/modal-encuesta-api.component';
import { ModalManualApiComponent } from './modals/modal-manual-api/modal-manual-api.component';
export { ModalCambiarUbicacionComponent } from './modals/modal-cambiar-ubicacion/modal-cambiar-ubicacion.component';
export { ModalCambiarLocalUniversidadComponent } from './modals/modal-cambiar-local-universidad/modal-cambiar-local-universidad.component';
export { ModalUbicacionLocalesUniversidadComponent } from './modals/modal-ubicacion-locales-universidad/modal-ubicacion-locales-universidad.component';
export { ModalLocalesUniversidadComponent } from './modals/modal-locales-universidad/modal-locales-universidad.component';
import { environment } from 'src/environments/environment';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ModalGestionaApiComponent } from './modals/modal-gestiona-api/modal-gestiona-api.component';
import { ButtonFichaComponent } from './button-ficha/button-ficha.component';

@NgModule({
  declarations: [
    PageTitleBarComponent,
    UploadCargaMasivaComponent,
    LayoutComponent,
    MenuComponent,
    PageContainerComponent,
    ComparadorUniversidadComponent,
    ComparadorProgramaComponent,
    ModalCambiarUbicacionComponent,
    VisorRangoEdadComponent,
    ModalCambiarLocalUniversidadComponent,
    ModalUbicacionLocalesUniversidadComponent,
    ModalLocalesUniversidadComponent,
    ModalPorQueUbicarmeComponent,
    ButtonScrollComponent,
    ModalSolicitudApiComponent,
    ModalBuscaKeyComponent,
    ModalEncuestaApiComponent,
    ModalManualApiComponent,
    ModalGestionaApiComponent,
    ButtonFichaComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    GoogleMapsModule,
    NgxCaptchaModule,
  ],
  providers: [
    UploadCargaMasivaService,
  ],
  exports: [
    PageTitleBarComponent,
    UploadCargaMasivaComponent,
    LayoutComponent,
    PageContainerComponent,
    ComparadorUniversidadComponent,
    ComparadorProgramaComponent,
    ModalCambiarUbicacionComponent,
    VisorRangoEdadComponent,
    ModalCambiarLocalUniversidadComponent,
    ModalUbicacionLocalesUniversidadComponent,
    ModalLocalesUniversidadComponent,
    ButtonScrollComponent,
    ButtonFichaComponent
  ]
})
export class CoreComponentsModule { }
